import { Component, Input, OnInit } from '@angular/core';
import { IFaqDto } from '../../interfaces/Faq/ifaq-dto';

@Component({
  selector: 'app-faq-viewer',
  templateUrl: './faq-viewer.component.html',
  styleUrls: ['./faq-viewer.component.css']
})
export class FaqViewerComponent implements OnInit {
  @Input() faq: IFaqDto;
  @Input() loading: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
